import { CommonModule, DatePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { CmsConfig, UrlModule, provideDefaultConfig } from '@spartacus/core'
import { LaunchDialogService, SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { CustomDecimalPipe } from '../../../../pipes/custom-decimal.pipe'
import { SortByPipe } from '../../../../pipes/sort.pipe'
import { MaterialModule } from '../../../shared/material.module'
import { SharedModule } from '../../../shared/shared.module'
import { defaultAddCommentsPhotoLayoutConfig } from '../add-comments-photo-layout.config'
import { NewCreditClaimPhotoUploadModalModule } from '../new-credit-claim-photo-upload-modal/new-credit-claim-photo-upload-modal.module'
import { NewcreditClaimsWithOrderComponent } from './newcredit-claims-with-order.component'

@NgModule({
  declarations: [NewcreditClaimsWithOrderComponent, SortByPipe, CustomDecimalPipe],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    SharedModule,
    SpinnerModule,
    MaterialModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    NewCreditClaimPhotoUploadModalModule
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CreateCreditClaimOrderComponent: {
          component: NewcreditClaimsWithOrderComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig),
    DatePipe,
    CustomDecimalPipe,
    provideDefaultConfig(defaultAddCommentsPhotoLayoutConfig),
    LaunchDialogService
  ]
})
export class NewcreditClaimsWithOrderModule {}
